/** Budget line items that roll up into income.total (server-derived). */
const INCOME_LINE_KEYS = [
  'congregationalOffering',
  'sponsoringChurches',
  'associations',
  'mbcb',
  'otherSupport',
] as const;

/** Mission line items that roll up into missionGiving.total (server-derived). */
const MISSION_LINE_KEYS = [
  'cooperativeProgram',
  'associations',
  'margaretLackey',
  'otherMissionCauses',
] as const;

function nonNeg(v: number | null | undefined): number {
  if (v == null || Number.isNaN(v)) return 0;
  return v < 0 ? 0 : v;
}

export function sumMbcbBudgetReceiptCategories(income: {
  congregationalOffering?: number | null;
  sponsoringChurches?: number | null;
  associations?: number | null;
  mbcb?: number | null;
  otherSupport?: number | null;
} | null | undefined): number {
  if (!income) return 0;
  let s = 0;
  for (const k of INCOME_LINE_KEYS) {
    s += nonNeg(income[k]);
  }
  return Math.round(s * 100) / 100;
}

export function sumMbcbMissionGivingCategories(missionGiving: {
  cooperativeProgram?: number | null;
  associations?: number | null;
  margaretLackey?: number | null;
  otherMissionCauses?: number | null;
} | null | undefined): number {
  if (!missionGiving) return 0;
  let s = 0;
  for (const k of MISSION_LINE_KEYS) {
    s += nonNeg(missionGiving[k]);
  }
  return Math.round(s * 100) / 100;
}
